// actions/GroupChangeAction.ts
import actionResponse, { ActionResponse } from '../../ActionResponse';
import { DateTime } from 'luxon';
import { GroupView } from '@views/GroupView';
import React from 'react';
import { SelectChangeEvent } from '@mui/material';

export class GroupChangeAction {
  Execute(
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement> | SelectChangeEvent | DateTime | any,
    selectedGroup: GroupView,
    setSelectedGroup: React.Dispatch<React.SetStateAction<GroupView | null>>
  ): ActionResponse {
    try {
      const group: any = { ...selectedGroup };
      // Handle date change
      if (DateTime.isDateTime(e)) {
        group.startDate = e;
      }
      // Handle text input change
      else if ('currentTarget' in e && e.currentTarget !== null) {
        group[e.currentTarget.id] = e.currentTarget.value;
      }
      // Handle dropdown change
      else if ('target' in e && e.target !== null && e.target.name && e.target.name !== '') {
        group[e.target.name] = e.target.value === 'yes';
      }

      setSelectedGroup({ ...group });
      return actionResponse.Success('Group changed successfully');
    } catch (error) {
      return actionResponse.HandleError(error);
    }
  }
}
